import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

/** Infobulle de l'application (remplace l'attribut `title` natif) : #1c1c20 / #3a3a40, 11px, délai 300 ms. */
export default function DeskTip({ text, side = "bottom", children, testId }) {
  if (!text) return children;
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent side={side} sideOffset={6} data-testid={testId}>{text}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
